"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GUEST_COLORS = exports.MAIN_GUEST_COLOR = exports.HOST_COLOR = exports.FALLBACK_COLOR = void 0;
exports.FALLBACK_COLOR = {
    backgroundColor: 'var(--blue-dark)',
    borderColor: 'var(--blue-dark)',
    textColor: 'var(--gray-10)',
};
exports.HOST_COLOR = {
    backgroundColor: 'var(--blue-20)',
    borderColor: 'var(--blue-20)',
    textColor: 'var(--gray-100)',
};
exports.MAIN_GUEST_COLOR = {
    backgroundColor: 'var(--blue-100)',
    borderColor: 'var(--blue-100)',
    textColor: 'var(--primary-white)',
};
exports.GUEST_COLORS = [
    { backgroundColor: 'var(--blue-4)', borderColor: 'var(--blue-4)', textColor: 'var(--gray-100)' },
    { backgroundColor: 'var(--green-dark)', borderColor: 'var(--green-dark)', textColor: 'var(--gray-100)' },
    { backgroundColor: 'var(--green-100)', borderColor: 'var(--green-100)', textColor: 'var(--gray-100)' },
    { backgroundColor: 'var(--green-20)', borderColor: 'var(--green-20)', textColor: 'var(--gray-100)' },
    { backgroundColor: 'var(--red-dark)', borderColor: 'var(--red-dark)', textColor: 'var(--gray-100)' },
    { backgroundColor: 'var(--red-100)', borderColor: 'var(--red-100)', textColor: 'var(--gray-100)' },
    { backgroundColor: 'var(--red-20)', borderColor: 'var(--red-20)', textColor: 'var(--gray-100)' },
    { backgroundColor: 'var(--red-4)', borderColor: 'var(--red-4)', textColor: 'var(--gray-100)' },
    { backgroundColor: 'var(--butterscotch-dark)', borderColor: 'var(--butterscotch-dark)', textColor: 'var(--gray-100)' },
    { backgroundColor: 'var(--butterscotch-100)', borderColor: 'var(--butterscotch-100)', textColor: 'var(--gray-100)' },
    { backgroundColor: 'var(--butterscotch-20)', borderColor: 'var(--butterscotch-20)', textColor: 'var(--gray-100)' },
    { backgroundColor: 'var(--green-dark)', borderColor: 'var(--green-dark)', textColor: 'var(--gray-100)' },
    { backgroundColor: 'var(--green-100)', borderColor: 'var(--green-100)', textColor: 'var(--gray-100)' },
    { backgroundColor: 'var(--green-20)', borderColor: 'var(--green-20)', textColor: 'var(--gray-100)' },
    { backgroundColor: 'var(--green-4)', borderColor: 'var(--green-4)', textColor: 'var(--gray-100)' },
];
